/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BenchmarkDetailDto } from '../../models/benchmark-detail-dto';

export interface ApiAdminBenchmarksBenchmarkIdGet$Params {
  benchmarkId: string;
}

export function apiAdminBenchmarksBenchmarkIdGet(http: HttpClient, rootUrl: string, params: ApiAdminBenchmarksBenchmarkIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkDetailDto>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarksBenchmarkIdGet.PATH, 'get');
  if (params) {
    rb.path('benchmarkId', params.benchmarkId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BenchmarkDetailDto>;
    })
  );
}

apiAdminBenchmarksBenchmarkIdGet.PATH = '/api/Admin/benchmarks/{benchmarkId}';
